import { ENV } from '@env';

export const LAST_SELECTED_PANEL_STORAGE_KEY = 'lastSelectedPanel';

export const getLastSelectedPanel = () => {
  return localStorage.getItem(LAST_SELECTED_PANEL_STORAGE_KEY) ?? null;
};

export const setLastSelectedPanel = (panel: string | null) => {
  if (!panel) {
    localStorage.removeItem(LAST_SELECTED_PANEL_STORAGE_KEY);
    return;
  } else {
    localStorage.setItem(LAST_SELECTED_PANEL_STORAGE_KEY, panel);
  }
};

export function isDevOrStaging(): boolean {
  const env = (ENV as string).toLowerCase();
  return ['local', 'dev', 'stg'].includes(env);
}
